export default __webpack_public_path__ + "static/shruteeGanguly3-6c9893dad1c6911634a1002187ba47c9.jpg";